<template>
    <div @click="toggleMenu()" :class="{on: hamburger}" class="burger burger2">
        <span></span>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    computed: {
        hamburger() {
            return this.$store.state.hamburger
        }
    },
    watch: {
        hamburger() {
            if(this.isActive != this.hamburger) {
                this.toggleMenu()
            }
        },
    },
    methods: {
        toggleMenu() {
            this.isActive = !this.isActive
            this.$store.commit('TOGGLE_HAMBURGER_STATE', this.isActive)
        }
    }
}
</script>
<style lang="scss">
    .burger {
        width:24px;
        height:24px;
        border:none;
        background:transparent;
        position:relative;
        cursor:pointer;
        &:focus {
            outline:none;
        }
        &.burger2 {
            &:after,
            span {
                width:100%;
                height:3px;
                border-radius:100px;
                position:absolute;
                display:block;
                background:#E8E8E8;
            }
            &:before {
                width:70%;
                height:3px;
                left: 0;
                border-radius:100px;
                position:absolute;
                display: block;
                background:#E8E8E8;
            }
            &:after,
            &:before {
                content:"";
                transition: 0.3s width 0.4s;
            }

            &:after {
                top:0px;
                left:0px;
                margin-top:0px;
            }

            &:before {
                bottom:0px;
                right:0px;
                margin-bottom:0px;
            }
            span {
                top: 50%;
                margin-top: -2px;
                transition: transform 0.3s;
                &:before {
                    content:"";
                    background:#E8E8E8;
                    width: 100%;
                    height: 3px;
                    border-radius: 100px;
                    position: absolute;
                    left: 0px;
                    transition: transform 0.3s;
                }
            }
            &.on {
                &:after {
                    transition: all 0.2s;
                    width: 0%;
                    left: 0px;
                }

                &:before {
                    transition: all 0.2s;
                    width: 0%;
                    right: 0px;
                }

                span {
                    background: #595959;
                    transform: rotate(45deg);
                    transition: 0.3s transform 0.4s;
                    &:before {
                        background: #595959;
                        transform:rotate(-90deg);
                        transition: 0.3s transform 0.4s;
                    }
                }
            }
        } 
    }
</style>